module.exports = __webpack_public_path__ + "static/img/pdf.e0964cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf.png
// module id = vOIX
// module chunks = 1